import React from "react";
import "./Itinerary.css";

const Itinerary = ({ data, fromImg }) => {
  return (
    <div className="itinerary-container">
      <h4 className="itinerary-title">Itinerarys</h4>

      {data?.itineraries?.map((item, index) => (
        <div className="itinerary-card" key={index}>
          <div className="location-header">{item?.title}</div>

          <div className="day-body">
            <h5 dangerouslySetInnerHTML={{ __html: item?.description }}></h5>
            {/* <div className="timing">
              <i className="fa-regular fa-clock"></i> Timing
            </div> */}

            <div className="route-section">
              <div className="route-box">
                <p className="label">From</p>

                <div className="port-box">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/images/cruise/cruise details/cruise-description/singapur-melaka.png"
                    }
                    alt=""
                    className="port-icon"
                  />
                  {item?.ship_from}
                </div>

                <div className="footer_div">
                  <div className="timing">
                    <i className="fa-regular fa-clock"></i> Timing
                  </div>

                  <span className="time">ETA:- {item?.time_from}</span>
                </div>
              </div>

              <div className="route-line"></div>

              <div className="route-box">
                <p className="label">To</p>

                <div className="port-box">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/images/cruise/cruise details/cruise-description/singapur-melaka.png"
                    }
                    alt=""
                    className="port-icon"
                  />
                  {item?.to}
                </div>

                <div className="footer_div">
                  <div className="timing">
                    <i className="fa-regular fa-clock"></i> Timing
                  </div>

                  <span className="time">ETD:- {item.time_to}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Itinerary;
